/* eslint-disable @typescript-eslint/no-unused-vars */

import { ToastContainer } from 'react-toastify'
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from 'dayjs'
import {
  NavigateOptions,
  useNavigate,
  useParams,
  Route,
  Link,
} from 'react-router-dom'
import { FacialRed } from '../../assets/icons/FacialRed'
import { HistoryIcon } from '../../assets/icons/history'
import { ReturnIcon } from '../../assets/icons/Return'
import { CardIconTitle } from '../../components/CardIconTitle/CardIconTitle'
import { GenericTable } from '../../components/GenericTable/GenericTable'
import { Loading } from '../../components/Loading/Loading'
import { ContainerTitle } from '../../components/TitlePage/TitlePage'
import { Tour } from '../../components/Tour'
import { colors } from '../../theme'
import TourPredicoesDetails from '../../utils/JoyRide/tourPredicoesDetails'
import { dateToBr } from '../../utils/transformDate'
import {
  ButtonGerarPdf,
  ButtonHistoricoBaixa,
  Calendars,
  DatePickerStyle,
  Div,
  DivButtonHistoricoBaixa,
  DivHeaderContent,
  DivImg,
  DivName,
  DivTablePaginacao,
  DivTop,
  FiltersCalendar,
  IconDismiss,
  LinkWpp,
  Span,
  SpanData,
  TitleAndCalendar,
  TypesFilter,
  Wrapper,
} from './PredictionDetails.style'
import { usePredictionDetails } from './usePredictionDetails'
import { MailIcon } from '../../assets/icons/mail'
import { PhoneIcon } from '../../assets/icons/phone-telephone'
import { WhatsappIcon } from '../../assets/icons/whatsapp-line'
import { UseFormatador } from '../../components/FormatadorCpfCnpj'
import { PaginationHistoryPredict } from '../../components/Pagination/Pagination'
import DatesPicker from '../../components/Calendar/datePicker'
import { Button } from '../../components/SideBar/Menu.style'

// eslint-disable-next-line import/no-extraneous-dependencies
import 'dayjs/locale/pt-br'
import SearchPlus from '../../assets/icons/searchPlus'
import { FilePdfIcon } from '../../assets/icons/file-pdf'
import { ProductDetailsPredictions } from '../../components/ProductDetailsPredictions'
import { MixRecomendacoes } from '../../components/MixRecomendacoes/MixRecomendacoes'
import { MixChamariz } from '../../components/MixRecomendacoes/MixChamariz'
import Tooltips from '../../components/Tooltip'
import { HistoricoDeBaixas } from '../../components/HistoricoDeBaixas'
import { CriarPedido } from '../../components/CriarPedido'

export function PredictionDetails() {
  const { formatarCPF } = UseFormatador()
  const {
    predictionHistory,
    predictionSoldOff,
    clientData,
    isLoading,
    isLoadingHistory,
    isLoadingSoldOff,
    baixasSelecionadas,
    toggleBaixaSelecionada,
    todasBaixasSelecionadas,
    toggleTodasBaixasSelecionadas,
    dismissLote,
    currentPageHistory,
    currentPageSoldOff,
    setCurrentPageHistory,
    setCurrentPageSoldOff,
    setCalendarInicio,
    handleIsProductDetails,
    isProductDetails,
    consultar,
    productDetails,
    handleGerarPdf,
    isGeneratingPdf,
    handleIsHistoricoBaixa,
    isHistoricoBaixa,
    handleIsCriarPedido,
    isCriarPedido,
  } = usePredictionDetails()
  const data = localStorage.getItem('dataInicio')

  // Mesmo guard da DT-37 que `usePredictionDetails` já tinha: os dois rodam nesta mesma
  // tela, então protegê-lo só no hook não evitava o crash. `/predicao/:id` é aberto em ABA
  // NOVA pelo painel do Mix, que passou a valer para vendedor/assistente/coordenador — carga
  // fria, sem `dataInicio` gravada. Sem data, cai em hoje.
  const dataSelecionadaPredicao = data ? JSON.parse(data) : null
  const dataFormatada = dataSelecionadaPredicao
    ? dataSelecionadaPredicao.split('/')
    : []
  const dataValida = dataSelecionadaPredicao
    ? `${dataFormatada[1]}/${dataFormatada[0]}/${dataFormatada[2]}`
    : ''
  const formatData = dataValida ? dayjs(dataValida) : dayjs()

  const { state } = useParams()

  const navigateOptions: NavigateOptions = {
    state: {
      filtro1: state,
    },
  }

  const navigate = useNavigate()
  const goToPage = () => {
    navigate('/predicoes', navigateOptions)
  }

  const handleFiltroDataInicio = (event: string) => {
    localStorage.setItem('dataInicio', JSON.stringify(event))
    setCalendarInicio(event)
  }

  return (
    <>
      <ToastContainer theme="dark" />
      <ContainerTitle id="saudacaoPredicaoDetail">
        <DivTop>
          <Link to="/predicoes">
            <ReturnIcon />
          </Link>
          <Span>Predição</Span>
        </DivTop>
        <Tooltips icon={<Tour steps={TourPredicoesDetails} />} text="Tour" />
      </ContainerTitle>
      <DivImg>
        {isLoading ? (
          <Loading contrast />
        ) : (
          <DivHeaderContent>
            <div>
              <DivName>{clientData?.nome}</DivName>
              <SpanData>
                CPF / CNPJ: {formatarCPF(clientData?.cpfcnpj)}
              </SpanData>
              <SpanData>
                <PhoneIcon /> {clientData?.telefone}
                <MailIcon /> {clientData?.email}
                <WhatsappIcon />
                <LinkWpp
                  href={`https://web.whatsapp.com/send?phone=${clientData?.whatsapp}`}
                  target="_blank"
                >
                  {clientData?.whatsapp}
                </LinkWpp>
              </SpanData>
            </div>
            <ButtonGerarPdf
              type="button"
              disabled={isGeneratingPdf}
              onClick={() => {
                handleGerarPdf()
              }}
            >
              <FilePdfIcon />
              {isGeneratingPdf ? 'Gerando PDF...' : 'Gerar PDF'}
            </ButtonGerarPdf>
          </DivHeaderContent>
        )}
      </DivImg>
      <Div id="finalizacaoPredicao">
        <Wrapper alinhamento className="firstCard">
          <TitleAndCalendar>
            <CardIconTitle
              icon={<HistoryIcon />}
              background={colors.grey200}
              title="Histórico"
            />
          </TitleAndCalendar>
          <GenericTable
            font="14px"
            spacing="20px"
            headers={[
              // 'ID',
              'Produto',
              'Última compra',
              'Qtd.',
            ]}
            title4
          >
            {isLoadingHistory ? (
              <Loading contrast={false} />
            ) : (
              predictionHistory &&
              Array.isArray(predictionHistory.content) &&
              predictionHistory.content.map(item => (
                <tr key={item.id}>
                  {/* <td>{item.id}</td> */}
                  <td className="col2">{item.nome}</td>
                  <td className="col3">{dateToBr(item.ultimaCompra)}</td>
                  <td className="colVendas6">{item.quantidade}</td>
                </tr>
              ))
            )}
          </GenericTable>
          <PaginationHistoryPredict
            pageNumber={currentPageHistory}
            pageSize={predictionHistory.totalElements}
            offSet={predictionHistory.size}
            onClick={page => setCurrentPageHistory(page)}
          />
        </Wrapper>
        <Wrapper alinhamento className="secondCard">
          <DivTablePaginacao>
            <TitleAndCalendar>
              <CardIconTitle
                icon={<FacialRed />}
                background={colors.lightRed}
                title="Produtos esgotando"
                color={colors.errorText}
              />
              <TypesFilter>
                <FiltersCalendar
                  type="button"
                  // onClick={handleShowFilterDate}
                >
                  {/* Data venda
              <ArrowDown /> */}
                  <Calendars>
                    <DatePickerStyle>
                      Data:
                      <DatesPicker
                        handleDataSelecionada={handleFiltroDataInicio}
                        size="130px"
                        dayjs={formatData}
                        background
                      />
                    </DatePickerStyle>
                  </Calendars>
                  <Button
                    buttonType="SMALL"
                    type="button"
                    onClick={() => {
                      handleIsCriarPedido()
                    }}
                  >
                    Criar pedido
                  </Button>
                  <Button
                    buttonType="SMALL"
                    type="button"
                    onClick={() => {
                      dismissLote()
                    }}
                  >
                    Dar baixa selecionados
                    {baixasSelecionadas.length > 0
                      ? ` (${baixasSelecionadas.length})`
                      : ''}
                  </Button>
                </FiltersCalendar>
              </TypesFilter>
            </TitleAndCalendar>
            <GenericTable
              font="14px"
              spacing="20px"
              headers={[
                // 'ID',
                <input
                  type="checkbox"
                  checked={todasBaixasSelecionadas}
                  onChange={() => toggleTodasBaixasSelecionadas()}
                  aria-label="Selecionar todos"
                />,
                'Produto',
                'Última compra',
                'Próx. compra',
                // 'Qtd.',
                'Consultar',
              ]}
            >
              {isLoadingSoldOff ? (
                <Loading contrast={false} />
              ) : (
                predictionSoldOff.content &&
                Array.isArray(predictionSoldOff.content) &&
                predictionSoldOff.content.map(item => (
                  <tr id="darBaixa" key={item.id}>
                    <td className="colVendas6">
                      <input
                        type="checkbox"
                        checked={baixasSelecionadas.includes(item.id)}
                        onChange={() => toggleBaixaSelecionada(item.id)}
                      />
                    </td>
                    <td className="colPredictionDetails">{item.nome}</td>
                    <td className="col3">{dateToBr(item.ultimaCompra)}</td>
                    <td className="col3">{dateToBr(item.proximaCompra)}</td>
                    <td className="colVendas6">
                      <IconDismiss onClick={() => consultar(item.id)}>
                        <SearchPlus />
                      </IconDismiss>
                    </td>
                  </tr>
                ))
              )}
            </GenericTable>
          </DivTablePaginacao>
          <DivButtonHistoricoBaixa>
            <ButtonHistoricoBaixa
              onClick={() => {
                handleIsHistoricoBaixa()
              }}
              id="anexar"
              htmlFor="files"
            >
              <HistoryIcon />
              Histórico de baixas
            </ButtonHistoricoBaixa>
            <PaginationHistoryPredict
              pageNumber={currentPageSoldOff}
              pageSize={predictionSoldOff.totalElements}
              offSet={predictionSoldOff.size}
              onClick={page => setCurrentPageSoldOff(page)}
            />
          </DivButtonHistoricoBaixa>
        </Wrapper>
        {isHistoricoBaixa && (
          <HistoricoDeBaixas handleIsHistoricoBaixa={handleIsHistoricoBaixa} />
        )}
        {isCriarPedido && (
          <CriarPedido handleIsCriarPedido={handleIsCriarPedido} />
        )}
        {isProductDetails && (
          <ProductDetailsPredictions
            consumoMedioDiario={productDetails.consumoMedioDiario}
            dataCompraAntiga={productDetails.dataCompraAntiga}
            dataCompraRecente={productDetails.dataCompraRecente}
            diasConsumo={productDetails.diasConsumo}
            duracaoUltimaCompra={productDetails.duracaoUltimaCompra}
            nome={productDetails.nome}
            predicaoProximaCompra={productDetails.predicaoProximaCompra}
            quantidadeUltimaCompra={productDetails.quantidadeUltimaCompra}
            reposicaoTotal={productDetails.reposicaoTotal}
            handleIsProductDetails={handleIsProductDetails}
          />
        )}
      </Div>
      <MixRecomendacoes />
      <MixChamariz />
    </>
  )
}
